module.exports = __webpack_public_path__ + "static/media/quality-produce.113dfe04.png";